module.exports = __webpack_public_path__ + "img/气体管路.2b2c1787.jpg";